import { 
	GetAnswerSheetActionsTypes,
	GetAnswerSheetsActionsTypes,
	GetAnswerSheetsByAssessmentActionsTypes,
	CreateAnswerSheetActionsTypes, CreateAnswerSheetModel,
	UpdateAnswerSheetActionsTypes, UpdateAnswerSheetModel,
	DeleteAnswerSheetActionsTypes
} from './types';

// Get single answer sheet by ID
export const getAnswerSheetRequest = (id: number) => ({
	type: GetAnswerSheetActionsTypes.GET_ANSWER_SHEET,
	id
});

// Get all answer sheets for current user
export const getAnswerSheetsRequest = () => ({
	type: GetAnswerSheetsActionsTypes.GET_ANSWER_SHEETS,
});

// Get answer sheets by assessment ID
export const getAnswerSheetsByAssessmentRequest = (assessmentId: number) => ({
	type: GetAnswerSheetsByAssessmentActionsTypes.GET_ANSWER_SHEETS_BY_ASSESSMENT,
	assessmentId
});

// Create new answer sheet
export const createAnswerSheetRequest = (model: CreateAnswerSheetModel) => ({
	type: CreateAnswerSheetActionsTypes.POST_CREATE_ANSWER_SHEET,
	model
});

// Update existing answer sheet
export const updateAnswerSheetRequest = (id: number, model: UpdateAnswerSheetModel) => ({
	type: UpdateAnswerSheetActionsTypes.PUT_UPDATE_ANSWER_SHEET,
	id,
	model
});

// Delete answer sheet
export const deleteAnswerSheetRequest = (id: number) => ({
	type: DeleteAnswerSheetActionsTypes.DELETE_ANSWER_SHEET,
	id
});
